import {
  SENSOR_VIEW_SETTINGS_ROUTE,
  SENSOR_VIEW_INFO_ROUTE,
  SENSOR_CREATE_ROUTE,
  SENSOR_EDIT_ROUTE,
  SENSOR_VIEW_ROUTE,
  SENSORS_ROUTE,
} from '@/config/routes/sensors';
import { ZONE_EDIT_ROUTE, ZONE_VIEW_INFO_ROUTE, ZONE_VIEW_ROUTE } from '@/config/routes/zones';

export default [
  {
    path: SENSORS_ROUTE.ROUTE_PATH,
    components: {
      default: () => import('./SensorContainer.vue')
    },
    meta: {
      privileges: SENSORS_ROUTE.PRIVILEGES
    },
    children: [
      // {
      //   path: SENSOR_CREATE_ROUTE.ROUTE_PATH,
      //   name: SENSOR_CREATE_ROUTE.ROUTE_NAME,
      //   meta: {
      //     privileges: SENSOR_CREATE_ROUTE.PRIVILEGES,
      //     scopeSelectorDisabled: true
      //   },
      //   components: {
      //     default: () => import('./SensorCreatePage.vue')
      //   }
      // },
      {
        path: '',
        name: SENSORS_ROUTE.ROUTE_NAME,
        components: {
          default: () => import('./SensorsAndZonesListPage.vue')
        }
      },
      {
        path: SENSOR_VIEW_ROUTE.ROUTE_PATH,
        meta: {
          privileges: SENSOR_VIEW_ROUTE.PRIVILEGES,
          scopeSelectorDisabled: true
        },
        components: {
          default: () => import('./SensorContainerView.vue')
        },
        children: [
          {
            path: SENSOR_VIEW_INFO_ROUTE.ROUTE_PATH,
            name: SENSOR_VIEW_INFO_ROUTE.ROUTE_NAME,
            meta: {
              privileges: SENSOR_VIEW_INFO_ROUTE.PRIVILEGES
            },
            components: {
              default: () => import('./SensorViewInfoPage.vue')
            }
          },
          {
            path: SENSOR_VIEW_SETTINGS_ROUTE.ROUTE_PATH,
            name: SENSOR_VIEW_SETTINGS_ROUTE.ROUTE_NAME,
            meta: {
              privileges: SENSOR_VIEW_SETTINGS_ROUTE.PRIVILEGES
            },
            components: {
              default: () => import('./SensorViewConfigPage.vue')
            }
          },
          {
            path: SENSOR_EDIT_ROUTE.ROUTE_PATH,
            name: SENSOR_EDIT_ROUTE.ROUTE_NAME,
            meta: {
              privileges: SENSOR_EDIT_ROUTE.PRIVILEGES
            },
            components: {
              default: () => import('./SensorEditPage.vue')
            }
          },
        ]
      },
      {
        path: ZONE_VIEW_ROUTE.ROUTE_PATH,
        meta: {
          privileges: ZONE_VIEW_ROUTE.PRIVILEGES,
          scopeSelectorDisabled: true
        },
        components: {
          default: () => import('@/views/intrusion/zone-view/ZoneViewRoute.vue')
        },
        children: [
          {
            path: ZONE_VIEW_INFO_ROUTE.ROUTE_PATH,
            name: ZONE_VIEW_INFO_ROUTE.ROUTE_NAME,
            meta: {
              privileges: ZONE_VIEW_INFO_ROUTE.PRIVILEGES
            },
            components: {
              default: () => import('@/views/intrusion/zone-view/ZoneViewPage.vue')
            }
          },
          {
            path: ZONE_EDIT_ROUTE.ROUTE_PATH,
            name: ZONE_EDIT_ROUTE.ROUTE_NAME,
            meta: {
              privileges: ZONE_EDIT_ROUTE.PRIVILEGES
            },
            components: {
              default: () => import('@/views/intrusion/zone-view/ZoneEditPage.vue')
            }
          }
        ]
      }
    ]
  }
];
